import {alphanumericKeyset, specialCharsKeyset} from '../Constants/keysets';
import KeysetType, {TKeysetType} from '../Constants/KeysetType';
import IKey from '../Interfaces/IKey';

class KeysetState {
    public type: TKeysetType;

    constructor(type: TKeysetType) {
        this.type = type;
    }

    public get isAlphanumeric(): boolean {
        return this.type === KeysetType.ALPHANUMERIC;
    }

    public get isSpecialChars(): boolean {
        return this.type === KeysetType.SPECIAL_CHARS;
    }

    public get keyset(): IKey[] {
        switch (this.type) {
            case KeysetType.ALPHANUMERIC:
                return alphanumericKeyset;
            case KeysetType.SPECIAL_CHARS:
                return specialCharsKeyset;
        }
    }

    public get altType(): TKeysetType {
        switch (this.type) {
            case KeysetType.ALPHANUMERIC:
                return KeysetType.SPECIAL_CHARS;
            case KeysetType.SPECIAL_CHARS:
                return KeysetType.ALPHANUMERIC;
        }
    }

    public get isShiftDisabled(): boolean {
        return this.isSpecialChars;
    }
}

export default KeysetState;
